import React from "react";
import { ResponsiveSelect } from "../../../../../components/MobileForm";
import { useResponsive } from "../../../../../hooks/useResponsive";
import { BREAKPOINTS } from "../../../../../utils/constants";
import { ALL_YEARS_VALUE } from "../../hooks/useYearFilter";
import { FilterRow } from "../../styles";
import type { YearFilterProps } from "./types";

export const YearFilter: React.FC<YearFilterProps> = ({
  yearOptions,
  selectedYearOption,
  handleYearChange,
}) => {
  const isCompact = useResponsive(BREAKPOINTS.tabletMin);

  return (
    <FilterRow>
      <ResponsiveSelect
        isCompact={isCompact}
        options={yearOptions}
        value={selectedYearOption?.value ?? ALL_YEARS_VALUE}
        onChange={handleYearChange}
        sheetTitle="Select year"
        placeholder="All years"
      />
    </FilterRow>
  );
};
